import React from "react";
import { motion } from "framer-motion";
import { AMENITIES } from "../../data/content";
import { SectionHeading } from "../shared/Primitives";
import { Blob, Sparkle } from "../shared/Decor";

export const Amenities = () => {
  return (
    <section id="amenidades" data-testid="amenities-section" className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-28">
      <Blob className="absolute -top-16 -left-20 w-72 text-khaki/30" />
      <Sparkle className="absolute top-24 right-12 w-8 text-camel/50 hidden sm:block" />
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 relative z-10">
        <SectionHeading
          overline="Todo incluido"
          title="Amenidades"
          subtitle="Espacios y servicios pensados para que tu día a día fluya con comodidad."
        />

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {AMENITIES.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                data-testid={`amenity-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 4) * 0.07 }}
                whileHover={{ y: -6 }}
                className="group rounded-2xl bg-linen border border-khaki/50 p-8 transition-colors duration-300 hover:bg-cocoa hover:border-cocoa"
              >
                <span className="flex items-center justify-center w-14 h-14 rounded-full bg-camel/20 text-cocoa transition-all duration-300 group-hover:bg-linen/15 group-hover:text-linen">
                  <Icon size={26} strokeWidth={1.6} />
                </span>
                <h3 className="mt-6 text-lg font-bold text-espresso transition-colors duration-300 group-hover:text-linen">
                  {item.title}
                </h3>
                <p className="mt-2 text-base font-light text-espresso/55 leading-relaxed transition-colors duration-300 group-hover:text-linen/75">
                  {item.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
